import {
    OnInit,
    Component,
    ViewChild,
    ViewEncapsulation,
    Input,
    TemplateRef,
    AfterViewInit,
    Directive,
    ViewContainerRef
} from '@angular/core';
import { style, state, animate, transition, trigger} from "@angular/animations";
import { AngularFirestoreCollection, AngularFirestore} from "angularfire2/firestore";
import { MatPaginator, MatTableDataSource, MatSort, MatDialog, MatSnackBar, SortDirection, MatIconRegistry } from '@angular/material';
import { CheckitEvent, Registrant, Stats } from '../checkit.model';
import { Router } from "@angular/router";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { merge } from 'rxjs/observable/merge';
import { zip } from 'rxjs/observable/zip';
import { of } from 'rxjs/observable/of';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import {
    DeleteRegistantDialog, PreviewDialogComponent, EmailEditDialogComponent, CustomUidsDialog, RegistrantDialogComponent,
    CheckinInformationDialogComponent, SendTestDialogComponent, ProgressMessageDialogComponent, RecipientsDialogComponent
} from './dialogs';
import { IconedSnackBar } from "./snackbars";
import { firestore } from "firebase"
import { AuthService } from '../../../core/auth.service';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from 'angularfire2/storage';
import { DatePipe } from '@angular/common';
import { EmailService } from '../../../core/email.service';
import { TimePipe }from 'app/shared/time.pipe';
import * as jsPDF from 'jspdf'
import { StateService } from 'app/core/state.service';
import { DownloadService } from '../../../core/download.service';
import { DomSanitizer } from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {observable} from 'rxjs/symbol/observable';
/**
 * Created by greg on 9/03/2018.
 */

@Component({
    selector: 'event-dashboard',
    styleUrls: [`event-dashboard.styl`],
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, void', style({ height: '0', padding:0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])],
    template: `
        <div class="summary_content">
            <div class="mobile_header"><span>Event Details</span>
                <mat-icon (click)="detailPanel = detailPanel == 'expand' ? 'collapse' : 'expand'">
                    {{detailPanel == 'expand' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                </mat-icon>
            </div>
            <div class="detail_panel panel" [@drop]="detailPanel">
                <div class="title2" [ngClass]="{closed:!permission['event-edit-details']}">Event Details
                    <button class="edit" (click)="editEvent()" *ngIf="permission['event-edit-details']">
                        <mat-icon>mode_edit</mat-icon>
                    </button>
                </div>
                <div class="details">
                    <div><b>Date:</b> {{(theEvent | async)?.date.toDate() | date:'EEEE d MMMM y'}}</div>
                    <div><b>Time:</b> {{(theEvent | async)?.start}} &ndash; {{(theEvent | async)?.end}}</div>
                    <div><b>Venue:</b> {{(theEvent | async)?.venue}}</div>
                    <div><b>Address:</b> {{(theEvent | async)?.address}}</div>
                    <div><b>Venue URL:</b> {{(theEvent | async)?.venue_url}}</div>
                </div>
                <button mat-button color="primary" class="mobile" (click)="editEvent()" *ngIf="permission['event-edit-details']">Edit event details</button>
            </div>
            <div class="mobile_header"><span>Event Statistics</span>
                <mat-icon (click)="statPanel = statPanel == 'expand' ? 'collapse' : 'expand'">
                    {{statPanel == 'expand' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                </mat-icon>
            </div>
            <div class="stat_panel panel" [ngClass]="{no_registrants_available:!areRegistrants}" [@drop]="statPanel">
                <div class="stats">
                    <div class="data">
                        <span>{{stats.invited || 0}}</span><span class="small">{{'/' + stats.list_count || 0 }}</span>
                        <div>INVITED</div>
                    </div>
                    <div class="data"><span>{{stats.attending || 0 }}</span>
                        <div>ATTENDING</div>
                    </div>
                    <div class="data"><span>{{stats.checkedIn || 0 }}</span>
                        <div>CHECKED IN</div>
                    </div>
                    <div class="data"><span>{{stats.walk_ins || 0 }}</span>
                        <div>WALK-INS</div>
                    </div>
                </div>
                <div class="downloads require_registrants">
                    <button (click)="download.forReport(evnt.title, dataSource.data)" [disabled]="!permission['event-download-report']">Download Report</button>
                    <button (click)="download.forData(evnt.title, evnt.use_custom_id)" [disabled]="!permission['event-download-data']">Download Data</button>
                    <button (click)="download.forBadges(evnt.title)" [disabled]="!permission['event-download-badges']">Name Badges</button>
                </div>
            </div>
        </div>
        <div *ngIf="(theEvent | async)?.use_custom_id" class="warning_panel">
            NOTE: You have opted to use your own custom unique identifier. Checkit is not validating the uniqueness of your records.
            <button (click)="confirmRestoreUids()">Restore...</button>
        </div>
        <div class="mobile_header"><span>Contact List</span>
            <mat-icon (click)="peoplePanel = peoplePanel == 'expand' ? 'collapse' : 'expand'">
                {{peoplePanel == 'expand' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
            </mat-icon>
        </div>
        <div class="people_panel panel" [@drop]="peoplePanel">
            <div class="menu_panel panel" [ngClass]="{no_registrants_available:!areRegistrants}">
                <div class="menu_panel_header">Contact List</div>
                <div [ngTemplateOutlet]="primaryFunctions('desktop')"></div>
            </div>
            <div [ngTemplateOutlet]="primaryFunctions('tablet')"></div>
            <div [ngTemplateOutlet]="secondaryFunctionTemplate"></div>

            <alert-panel [(message)]="alert_message"></alert-panel>
            <div class="sub_menu tablet">
                <ng-container [ngTemplateOutlet]="tertiaryFunctions('tablet')"></ng-container>
            </div>
            <div class="sub_menu mobile">
                <ng-container [ngTemplateOutlet]="mobileButtonTemplate"></ng-container>
            </div>
            <div class="sub_menu">
                <div class="search_content" [ngClass]="{hide:!areRegistrants}">
                    <mat-icon>search</mat-icon>
                    <input #searchInput (keyup)="applyFilter($event.target.value)"/>
                    <mat-icon (click)="searchInput.value = ''">close</mat-icon>
                </div>
                <div mat-icon-button class="tune" [matMenuTriggerFor]="filterMenu" [ngClass]="{hide: !areRegistrants}">
                    <mat-icon>tune</mat-icon>
                </div>

                <div [ngTemplateOutlet]="tertiaryFunctions('desktop')"></div>

                <div style="flex:1"></div>
                <mat-paginator [ngClass]="{requires_registrants:!areRegistrants}" #paginator [pageSize]="5000"
                               hidePageSize="true"></mat-paginator>
            </div>
            
            <spreadsheet (action)="importAction($event)" [use_custom_id]="evnt?.use_custom_id"></spreadsheet>

            <div class="attendees_content" [ngClass]="{no_registrants_available:!areRegistrants}">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row (click)="updateRegistrant($event, row)" *matRowDef="let row; columns: displayedColumns;"></mat-row>

                    <ng-container matColumnDef="check_invitation">
                        <mat-header-cell *matHeaderCellDef class="chbox">
                            <mat-checkbox [checked]="invitation_selected_num == dataSource.data.length"
                                          [indeterminate]="chboxIndeterminate('invitation')"
                                          (click)="toggleListCheckbox('invitation')"></mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="chbox">
                            <mat-checkbox color="primary" [checked]="reg.send_invitation"
                                          (click)="checkToSendEmail($event, 'invitation', reg)"></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="check_email">
                        <mat-header-cell *matHeaderCellDef class="chbox">
                            <mat-checkbox [checked]="email_selected_num == dataSource.data.length"
                                          [indeterminate]="chboxIndeterminate('email')"
                                          (click)="toggleListCheckbox('email')"></mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="chbox">
                            <mat-checkbox color="primary" [checked]="reg.send_email"
                                          (click)="checkToSendEmail($event, 'email', reg)"></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="check_ticket">
                        <mat-header-cell *matHeaderCellDef class="chbox">
                            <mat-checkbox [checked]="ticket_selected_num == dataSource.data.length"
                                          [indeterminate]="chboxIndeterminate('ticket')"
                                          (click)="toggleListCheckbox('ticket')"></mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="chbox">
                            <mat-checkbox color="primary" [checked]="reg.send_ticket"
                                          (click)="checkToSendEmail($event, 'ticket', reg)"></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="scanId">
                        <mat-header-cell *matHeaderCellDef class="col8" mat-sort-header>Unique ID</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col8">{{reg.scanId}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell *matHeaderCellDef class="col8" mat-sort-header>First Name</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col8">{{reg.firstName}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell *matHeaderCellDef class="col8" mat-sort-header>Last Name</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col8"> {{reg.lastName}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="truncate">{{reg.email}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="company">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Company</mat-header-cell>
                        <mat-cell *matCellDef="let reg">{{reg.company}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="phone">
                        <mat-header-cell *matHeaderCellDef class="col5"></mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col5">
                            <mat-icon *ngIf="reg.phone" class="small text-grey">phone</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="invited">
                        <mat-header-cell *matHeaderCellDef class="col5">Invited</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col5">
                            <mat-icon *ngIf="reg.inviteSent" class="small text-green">check</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="attending">
                        <mat-header-cell *matHeaderCellDef class="col5">Attending</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col5">
                            <mat-icon *ngIf="reg.attending == 'accepted'" class="small text-green">check</mat-icon>
                            <mat-icon *ngIf="reg.attending == 'declined'" class="small text-red">close</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ticketSent">
                        <mat-header-cell *matHeaderCellDef class="col5">Ticket Sent</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col5">
                            <mat-icon *ngIf="reg.ticketSent" class="small text-green">check</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="checkedIn">
                        <mat-header-cell *matHeaderCellDef class="col5">Checked in</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col5">
                            <mat-icon *ngIf="reg.checkedIn" class="small text-green">check</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="walkin">
                        <mat-header-cell *matHeaderCellDef class="col5">Walk-in</mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col5">
                            <mat-icon *ngIf="reg.walkin" class="small text-green">check</mat-icon>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="sort">
                        <mat-header-cell *matHeaderCellDef>
                            Sort by:
                            <mat-select (change)="columnSort($event)">
                                <mat-option *ngFor="let opt of sort_options" [value]="opt.value">{{opt.label}}</mat-option>
                            </mat-select>
                            <mat-icon class="small" (click)="sortDirection = sortDirection == 'asc' ? 'desc' : 'asc'">
                                {{sortDirection == 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                            </mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let reg">
                            <div class="row1">
                                <mat-icon class="menu" *ngIf="screenMode=='mobile'" (click)="reg.show_detail = !reg.show_detail">
                                    {{reg.show_detail ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
                                </mat-icon>
                                <span class="name">{{reg.firstName + ' ' + reg.lastName}}, </span>
                                <span>{{reg.company}} <span *ngIf="screenMode!='mobile'">&bull; {{reg.email}}</span></span>
                                <mat-icon *ngIf="reg.phone && screenMode!='mobile'" class="small text-grey">phone</mat-icon>
                            </div>
                            <div class="row2" [ngClass]="{show:reg.show_detail}">
                                <span>Invited <mat-icon *ngIf="reg.inviteSent" class="small text-green">check</mat-icon></span>
                                <span class="long">Attending 
                                    <mat-icon *ngIf="reg.attending == 'accepted'" class="small text-green">check</mat-icon>
                                    <mat-icon *ngIf="reg.attending == 'declined'" class="small text-red">close</mat-icon>
                                </span>
                                <span class="long">Ticket Sent 
                                    <mat-icon *ngIf="reg.ticketSent" class="small text-green">check</mat-icon>
                                </span>
                                <span class="long">Checked in 
                                    <mat-icon *ngIf="reg.checkedIn" class="small text-green">check</mat-icon>
                                </span>
                                <span>Walk-in <mat-icon *ngIf="reg.walkin" class="small text-green">check</mat-icon></span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef class="col2">
                        </mat-header-cell>
                        <mat-cell *matCellDef="let reg" class="col2">
                            <div class="action_menu menu" [matMenuTriggerFor]="utilMenu">
                                <mat-icon class="menu">more_vert</mat-icon>
                            </div>
                            <mat-menu #utilMenu="matMenu" xPosition="before">
                                <button mat-menu-item [disabled]="!permission['event-individual-send-invitation']"  
                                        (click)="sendSingleEmail('invitation', reg)">Send Invitation</button>
                                <button mat-menu-item [disabled]="!permission['event-individual-send-email']"
                                        (click)="sendSingleEmail('email', reg)">Send Email</button>
                                <button mat-menu-item [disabled]="!permission['event-individual-send-ticket']"
                                        (click)="sendSingleEmail('ticket', reg)">Send Ticket</button>
                                <button mat-menu-item [disabled]="!permission['event-individual-edit']"
                                        (click)="updateRegistrant($event,reg)">Edit...</button>
                                <button mat-menu-item [disabled]="!permission['event-individual-delete']"
                                        (click)="deleteRegistant(reg)">Delete...</button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                </mat-table>
                <mat-menu #filterMenu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="showFilter('all')">Show All ({{stats.list_count}})</button>
                    <button mat-menu-item (click)="showFilter('invited')">Show Invited ({{stats.invited}})</button>
                    <button mat-menu-item (click)="showFilter('not-invited')">Show Not Invited
                        ({{stats.list_count - stats.invited}})
                    </button>
                    <button mat-menu-item (click)="showFilter('attending')">Show Attending ({{stats.attending}})</button>
                    <button mat-menu-item (click)="showFilter('not-attending')">Show Not Attending
                        ({{stats.list_count - stats.attending}})
                    </button>
                    <button mat-menu-item (click)="showFilter('checked-in')">Show Checked In ({{stats.checkedIn}})</button>
                    <button mat-menu-item (click)="showFilter('not-checked-in')">Show Not Checked In
                        ({{stats.list_count - stats.checkedIn}})
                    </button>
                    <button mat-menu-item (click)="showFilter('walkups')">Show Walk Ups ({{stats.walk_ins}})</button>
                </mat-menu>
            </div>
            <div class="no_registrant" *ngIf="!areRegistrants">
                <p>It looks like you haven't added any people yet.</p>
                <p>Click "Import List" or "Add Someone" to get started.</p>
            </div>
        </div>

        <ng-template #primaryFunctionTemplate>
            <div class="functions">
                <div class="seater" [ngClass]="{selected:zones_status[1]}">
                    <button [disabled]="!permission['event-send-invitations']" (click)="zoneToggle(1, 'invitation')">
                        <mat-icon>insert_invitation</mat-icon>
                        Send Invitations
                    </button>
                    <button-seat *ngIf="zones_status[1]" class="sharp_left"></button-seat>
                </div>
                <div class="seater" [ngClass]="{selected:zones_status[2]}">
                    <button [disabled]="!permission['event-send-email']" (click)="zoneToggle(2, 'email')">
                        <mat-icon>mail_outline</mat-icon>
                        Send Email
                    </button>
                    <button-seat *ngIf="zones_status[2]"></button-seat>
                </div>
                <div class="seater" [ngClass]="{selected:zones_status[3]}">
                    <button [disabled]="!permission['event-send-tickets']" (click)="zoneToggle(3, 'ticket')">
                        <mat-icon svgIcon="qrcode"></mat-icon>
                        Send Tickets
                    </button>
                    <button-seat *ngIf="zones_status[3]"></button-seat>
                </div>
                <div class="separator"></div>
                <div class="seater" [ngClass]="{selected:zones_status[4]}">
                    <button [disabled]="!permission['event-setup-check-in']" (click)="zoneToggle(4)">
                        <mat-icon svgIcon="checkit"></mat-icon>
                        Set Up Check-in
                    </button>
                    <button-seat *ngIf="zones_status[4]" class="sharp_right" config="sr"></button-seat>
                </div>
            </div>
        </ng-template>
        <ng-template #secondaryFunctionTemplate>
            <div class="function_panel  hide_til_initially_loaded" [ngClass]="{initially_loaded:initially_loaded}">
                <div class="box hide_til_initially_loaded" [ngClass]="{initially_loaded:initially_loaded}" [@drop]="invitationState">
                    <div class="invitation_box sharp_left">
                        <b>1. </b>
                        <button (click)="viewEmail('invitation')">View Invitation</button>
                        <b>2. </b>
                        <button (click)="selectRecipients('invitation')">Select Recipients</button>
                        <b>3. </b>
                        <button (click)="sendBatchEmail('invitation')">Send Invitations</button>
                        <div style="flex:1"></div>
                        <div class="cancel" (click)="zoneToggle(1)">Cancel</div>
                    </div>
                </div>
                <div class="box hide_til_initially_loaded" [ngClass]="{initially_loaded:initially_loaded}" [@drop]="emailState">
                    <div class="invitation_box">
                        <b>1. </b>
                        <button (click)="viewEmail('email')">View Email</button>
                        <b>2. </b>
                        <button (click)="selectRecipients('email')">Select Recipients</button>
                        <b>3. </b>
                        <button (click)="sendBatchEmail('email')">Send Emails</button>
                        <div style="flex:1"></div>
                        <div class="cancel" (click)="zoneToggle(2)">Cancel</div>
                    </div>
                </div>
                <div class="box hide_til_initially_loaded" [ngClass]="{initially_loaded:initially_loaded}" [@drop]="ticketState">
                    <div class="invitation_box">
                        <b>1. </b>
                        <button (click)="viewEmail('ticket')">View Ticket</button>
                        <b>2. </b>
                        <button (click)="selectRecipients('ticket')">Select Recipients</button>
                        <b>3. </b>
                        <button (click)="sendBatchEmail('ticket')">Send Tickets</button>
                        <div style="flex:1"></div>
                        <div class="cancel" (click)="zoneToggle(3)">Cancel</div>
                    </div>
                </div>
                <div class="box hide_til_initially_loaded" [ngClass]="{initially_loaded:initially_loaded}" [@drop]="setupState">
                    <div class="invitation_box sharp_right setup">
                        <div class="heading">How to set up check-in:</div>
                        <div class="intro">
                            <div class="step"><b>1.</b><span>Send check-in set up email</span></div>
                            <div class="step"><b>2.</b><span>Open email on your mobile </span></div>
                            <div class="step"><b>3.</b><span>Download Checkit app from the link in email</span></div>
                            <div class="step"><b>4.</b><span>Click on event link in email and start scanning</span></div>
                        </div>
                        <hr/>
                        <div class="controls">
                            <button class="blue" (click)="openEmailApp()">Open check-in set up email</button>
                            <button (click)="checkinInformation()">More information on check-in</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="function_bar_padding"></div>
        </ng-template>
        <ng-template #tertiaryFunctionTemplate>
            <button class="control" [disabled]="!permission['event-import-list']"><mat-icon>playlist_add</mat-icon>
                <label htmlFor="{{permission['event-import-list'] ? 'input-file-id': ''}}"> Import from spreadsheet</label>
            </button>
            <button class="control" (click)="addRegistrant()" [disabled]="!permission['event-add-someone']">
                <mat-icon>add</mat-icon>
                Add individual
            </button>
            <button class="plain" [ngClass]="{hide:!areRegistrants}" (click)="deleteRegistant('all')" [disabled]="!permission['event-remove-all']">Remove all</button>
        </ng-template>
        <ng-template #mobileButtonTemplate>
            <div class="control_group" [ngClass]="{collapse: mobileExpand!=''}">
                <div class="row">
                    <button class="control" (click)="mobileExpand='invitation'" [disabled]="!permission['event-send-invitations']">
                        <mat-icon>insert_invitation</mat-icon>
                        <span>Send Invitations</span>
                    </button>
                    <button class="control"  (click)="mobileExpand='email'" [disabled]="!permission['event-send-email']">
                        <mat-icon>mail_outline</mat-icon>
                        <span>Send Email</span>
                    </button>
                    <button class="control" (click)="mobileExpand='ticket'" [disabled]="!permission['event-send-tickets']">
                        <mat-icon svgIcon="qrcode"></mat-icon>
                        <span>Send Tickets</span>
                    </button>
                </div>
                <div class="row">
                    <button class="control" [disabled]="!permission['event-import-list']">
                        <label for="input-file-id"><mat-icon>playlist_add</mat-icon></label>
                        <span><label for="input-file-id">Import</label></span>
                    </button>
                    <button class="control" (click)="addRegistrant()" [disabled]="!permission['event-add-someone']">
                        <mat-icon>add</mat-icon>
                        <span>Add individual</span>
                    </button>
                    <button class="control" [ngClass]="{hide:!areRegistrants}" (click)="deleteRegistant('all')" [disabled]="!permission['event-remove-all']">
                        <mat-icon>delete</mat-icon>
                        <span>Remove all</span>
                    </button>
                </div>
            </div>
            <div class="email_group" [ngClass]="{expand: mobileExpand!=''}">
                <div style="border:1px solid #ddd; border-radius:6px; padding:15px 10px; ">
                    <div class="menu_title">
                        <mat-icon *ngIf="mobileExpand=='invitation'">insert_invitation</mat-icon>
                        <mat-icon *ngIf="mobileExpand=='email'">mail_outline</mat-icon>
                        <mat-icon svgIcon="qrcode" *ngIf="mobileExpand=='ticket'"></mat-icon>
                        <div>Send {{mobileExpand}}s</div>
                        <mat-icon class="close" (click)="mobileExpand=''">close</mat-icon>
                    </div>
                    <div class="menu_items">
                        <div><b>1.</b><button>View {{mobileExpand}}</button></div>
                        <div><b>2.</b><button>Select Recipients</button></div>
                        <div><b>3.</b><button>Send {{mobileExpand}}s</button></div>
                    </div>
                </div>
            </div>
        </ng-template>

    `,
    encapsulation: ViewEncapsulation.None
})
export class EventDashboardComponent implements OnInit, AfterViewInit {

    desktopColumns = ['firstName', 'lastName', 'email', 'company', 'phone', 'invited', 'attending', 'ticketSent',
        'checkedIn', 'walkin', 'actions'];
    tabletColumns = ['sort', 'actions'];
    dataSource = new MatTableDataSource<Registrant>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('primaryFunctionTemplate') primaryFunctionTemplate: TemplateRef<any>;
    @ViewChild('tertiaryFunctionTemplate') tertiaryFunctionTemplate: TemplateRef<any>;
    @Input() theEvent: Observable<CheckitEvent>;

    stats: Stats = new Stats();

    $destroy: Subject<boolean> = new Subject();
    registrantCollection: AngularFirestoreCollection<Registrant>;
    registrants: Observable<Registrant[]>;
    isLoadingResults = true;
    isRateLimitReached = false;
    areRegistrants = false;
    registrantCount: number = 0;
    evnt: CheckitEvent; // keep this for init loading
    zones_status = [0, 0, 0, 0, 0, 0];
    invitation_selected_num = 0;
    ticket_selected_num = 0;
    email_selected_num = 0;
    default_sender = '';
    invitation_default_body = 'Hi {{first_name}},\n\nYou’re invited to {{title}}.\n\n' +
        'For further information contact {{email}}. Please RSVP below.\n\nI hope to see you there!\n\n' +
        '{{displayName}}';
    email_default_body = 'Hi {{first_name}},\n\nThis email can be used for reminders, post-event emails or other event communications.\n\n'
        + 'For further information contact {{email}}.\n\n' + '{{displayName}}';
    ticket_default_body = 'Hi {{first_name}},\n\nBelow is your ticket to {{title}}. ' +
        'Bring this email on your mobile device to check-in on the day.\n\n' +
        'For further information contact {{email}}.\n\nLooking forward to seeing you there!\n\n' +
        '{{displayName}}';
    invitation_default_subject = 'Your invitation to {{title}}';
    email_default_subject = 'Your email to {{title}}';
    ticket_default_subject = 'Your ticket to {{title}}';
    invitation_template = 'invitation-template-20180517.html';
    email_template = 'email-template.html';
    ticket_template = 'ticket-template-20180524.html';
    sender_email = 'noreply@checkit.events';
    rendered_invitation_content = '';
    rendered_email_content = '';
    rendered_ticket_content = '';
    emails_ready_to_post = [];
    invitation_default_mail: any = {};
    ticket_default_mail: any = {};
    email_default_mail: any = {};
    alert_message = '';
    search_array = ['firstName', 'lastName', 'email', 'company'];
    sort_options = [{label: 'First name', value: 'firstName'}, {label: 'Last name', value: 'lastName'},
        {label: 'Email', value: 'email'}, {label: 'Company', value: 'company'}];
    displayedColumns = [];
    screenMode = '';
    _direction = 'asc';
    _active = '';
    detailPanel = 'collapse';
    statPanel = 'collapse';
    peoplePanel = 'collapse';
    auth_email = '';
    auth_firstName = '';
    auth_lastName = '';
    initially_loaded = false;
    subdomain = 'dev';
    permission: any = {};
    mobileExpand = '';
    eventStatus: Subject<string> = new Subject();


    get invitationState() {
        return this.zones_status[1] == 0 ? 'collapse' : 'expand';
    }
    get emailState() {
        return this.zones_status[2] == 0 ? 'collapse' : 'expand';
    }
    get ticketState() {
        return this.zones_status[3] == 0 ? 'collapse' : 'expand';
    }
    get setupState() {
        return this.zones_status[4] == 0 ? 'collapse' : 'expand';
    }
    get importState() {
        return this.zones_status[5] == 0 ? 'collapse' : 'expand';
    }
    get sortDirection() {
        return this._direction;
    }
    set sortDirection(dir) {
        this._direction = dir;
        this.sort.active = this.sortActive;
        this.sort.direction = dir as SortDirection;
        this.dataSource.sort = this.sort;
    }
    get sortActive() {
        return this._active;
    }
    set sortActive(act) {
        this._active = act;
        this.sort.active = act;
        this.sort.direction = this.sortDirection as SortDirection;
        this.dataSource.sort = this.sort;
    }
    import_data;
    afs: AngularFirestore;

    constructor(
        public state: StateService,
        public download: DownloadService,
        private router: Router,
        private dialog: MatDialog,
        private snackbar: MatSnackBar,
        private auth: AuthService,
        private storage: AngularFireStorage,
        private http: HttpClient,
        private datePipe: DatePipe,
        private timePipe: TimePipe,
        private email: EmailService, private iconReg: MatIconRegistry, private sanitizer: DomSanitizer
    ) {
        this.afs = auth.afs;
        if (this.state.accounts['currentId'] && this.state.checkit.event && this.state.checkit.event.hasOwnProperty('eventId')  ){
            this.registrantCollection = this.afs.collection<Registrant>(`accounts/${this.state.accounts['currentId']}/registrants`,
                ref => { return ref.where("eventId", '==' , this.state.checkit.event['eventId']); }
            );
            this.registrants = this.registrantCollection.valueChanges();
        }
        const location = window.document.location.href;
        if(/localhost:/.test(location)){
           this.subdomain = 'dev';
        }else{
           this.subdomain = location.split('://')[1].split('.checkit')[0];
        }
        this.state.screen.subscribe( mode => {
            if (this.screenMode != mode) {
                this.screenMode = mode;
                console.log(this.screenMode);
                if (this.screenMode == 'tablet') {
                    this.detailPanel = this.statPanel = this.peoplePanel = 'expand';
                    this.displayedColumns = this.tabletColumns;
                } else if (this.screenMode == 'mobile') {
                    this.detailPanel = this.statPanel = this.peoplePanel = 'collapse';
                    this.displayedColumns = this.tabletColumns;
                } else {
                    this.detailPanel = this.statPanel = this.peoplePanel = 'expand';
                    this.displayedColumns = this.desktopColumns;
                }
                this.zoneToggle(0);
            }
        });
        let mode = 'desktop';
        if (768 <= window.innerWidth && window.innerWidth <= 1280) {
            mode = 'tablet';
        } else if (window.innerWidth < 768) {
            mode = 'mobile';
        }
        this.state.screen.next(mode);
        iconReg.addSvgIcon('checkit', sanitizer.bypassSecurityTrustResourceUrl('assets/checkit_24px.svg'));
        iconReg.addSvgIcon('qrcode', sanitizer.bypassSecurityTrustResourceUrl('assets/qrcode_24px.svg'));
    }

    ngOnInit() {
        merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
            switchMap(() => {
                this.isLoadingResults = true;
                return this.registrants;
            }),
            map(data => {
                // Flip flag to show that loading has finished.
                this.isLoadingResults = false;
                this.isRateLimitReached = false;
                if (data && data.length){
                    this.areRegistrants = true;
                }else{
                    this.areRegistrants = false;
                }
                return data;
            }),
            catchError(() => {
                this.isLoadingResults = false;
                // Catch if the GitHub API has reached its rate limit. Return empty data.
                this.isRateLimitReached = true;
                return Observable.of([]);
            })
        ).subscribe(data => {
            // console.log(data);
            this.dataSource.data = data;
            this.populateStats(data);
            // console.log(this.sort.active, this.sort.direction);
        });
        this.eventStatus.subscribe(evnt => {
            console.log('###############################', this.state.rules, this.state.accountStatus, evnt);
            if (!this.state.rules || !this.state.accountStatus || !evnt) {
                this.permission = [];
            } else {
                for (const i in this.state.rules[this.state.accountStatus]) {
                    if (this.state.rules[evnt]) {
                        this.permission[i] =  this.state.rules[this.state.accountStatus][i] && this.state.rules[evnt][i];
                    } else {
                        this.permission[i] =  this.state.rules[this.state.accountStatus][i];
                    }
                }
            }
        })
        // const loading_permission = zip(this.state.$function_rules, this.state.accountStatus, this.eventStatus,
        //     (rules, acc, evnt) => {
        //         console.log('###############################', rules, acc, evnt);
        //         if (!rules || !acc || !evnt) {
        //             this.permission = [];
        //         } else {
        //             console.log(rules)
        //             // rules[acc].forEach( (rule, i) => {
        //             //     console.log(i, rule)
        //             //     // if (rules[evnt]) {
        //             //     //     this.permission[i] =  rules[acc][i] && rules[evnt][i];
        //             //     // } else {
        //             //     //     this.permission[i] =  rules[acc][i];
        //             //     // }
        //             // })
        //         }
        //     }).subscribe(x => console.log('loading permission'));

        // this.state.$function_rules.subscribe( rules => {
        //     this.state.accountStatus.subscribe( acc => {
        //         this.eventStatus.subscribe(evnt => {
        //             console.log('###############################', rules, acc, evnt);
        //         })
        //     });
        // });
        // this.state.accountStatus, this.eventStatus,
        //     (rules, acc, evnt) => {
        //         console.log('###############################', rules, acc, evnt);
        //         if (!rules || !acc || !evnt) {
        //             this.permission = [];
        //         } else {
        //             console.log(rules)
        //             // rules[acc].forEach( (rule, i) => {
        //             //     console.log(i, rule)
        //             //     // if (rules[evnt]) {
        //             //     //     this.permission[i] =  rules[acc][i] && rules[evnt][i];
        //             //     // } else {
        //             //     //     this.permission[i] =  rules[acc][i];
        //             //     // }
        //             // })
        //         }
        //     }).subscribe(x => console.log('loading permission'));
        //
        // this.loading_permission = combineLatest(this.eventStatus, this.state.$function_rules, this.state.accountStatus, (evnt, rules, acc) => {
        //     console.log('###############################', rules, acc, evnt);
        // }).subscribe(x => console.log('loading permission'));

        zip(this.auth.user, this.theEvent, (user, evnt) => {
            this.evnt = evnt;
            this.eventStatus.next(evnt.closed ? 'event-closed' : 'event-active');
            // this.eventStatus = Observable.create( observer => observer.next(evnt.closed ? 'event-closed' : 'event-active'));
            console.log('event closed:', evnt.closed);
            const scanId_pos = this.displayedColumns.indexOf('scanId');
            console.log('TODO: solve error (undefined evnt) when remove event at events page');
            if (evnt.use_custom_id) {
                if (scanId_pos == -1) this.displayedColumns.unshift('scanId');
            }else if(scanId_pos > -1) {
                this.displayedColumns.splice(scanId_pos, 1);
            }
            if (user) {
                this.auth_email = user.email;
                this.auth_firstName = user.firstName;
                this.auth_lastName = user.lastName;
                this.invitation_default_body = this.invitation_default_body.replace('{{email}}', user.email)
                    .replace('{{displayName}}', user.displayName);
                this.ticket_default_body = this.ticket_default_body.replace('{{email}}', user.email)
                    .replace('{{displayName}}', user.displayName);
                this.email_default_body = this.email_default_body.replace('{{email}}', user.email)
                    .replace('{{displayName}}', user.displayName);
                this.default_sender = user.displayName;
            }
            this.ticket_default_subject = this.ticket_default_subject.replace('{{title}}', evnt.title);
            this.invitation_default_subject = this.invitation_default_subject.replace('{{title}}', evnt.title);
            this.email_default_subject = this.email_default_subject.replace('{{title}}', evnt.title);
            this.invitation_default_body = this.invitation_default_body.replace('{{title}}', evnt.title);
            this.ticket_default_body = this.ticket_default_body.replace('{{title}}', evnt.title);
            this.email_default_body = this.email_default_body.replace('{{title}}', evnt.title);
            this.invitation_default_mail = { logo: '', sender: this.default_sender,
                subject: this.invitation_default_subject, body: this.invitation_default_body};
            this.ticket_default_mail = { logo: '', sender: this.default_sender,
                subject: this.ticket_default_subject, body: this.ticket_default_body};
            this.email_default_mail = { logo: '', sender: this.default_sender,
                subject: this.email_default_subject, body: this.email_default_body};

        }).subscribe(x => console.log('zipping ...'));


        setTimeout(_=> {
            this.initially_loaded = true;
        },1000);
        // this.state.$function_rules.subscribe( x => this.permission = x);
    }

    primaryFunctions(mode) {
        return this.screenMode == mode ? this.primaryFunctionTemplate : null;
    }
    tertiaryFunctions(mode) {
        return this.screenMode == mode ? this.tertiaryFunctionTemplate : null;
    }

    editEvent(){
        this.evnt.is_new =  this.evnt.is_duplicate = false;
        this.state.$requests.next({request: 'editEvent', editEvent: this.evnt});
    }

    populateStats(data){
        // reset stats
        this.stats = new Stats();
        this.registrantCount = data.length;
        // console.log('this.areRegistrants: ',this.areRegistrants, data);
        data.forEach(reg => {
            // console.log('item ', reg);
            if (reg.attending == 'accepted') this.stats.attending += 1;
            if (reg.inviteSent && reg.attending == 'pending') this.stats.unanswered += 1;
            if (reg.inviteSent) this.stats.invited += 1;
            if (reg.checkedIn) this.stats.checkedIn += 1;
            if (reg.walkin) this.stats.walk_ins += 1;
            this.stats.list_count += 1;
            this.stats.loaded = true;
        })
    }

    columnSort(ev) {
        console.log(ev.value);
        this.sortActive = ev.value;
    }
    public showFilter(key: string) {
        this.dataSource.filterPredicate = this.flag_filter(key);
        this.dataSource.filter = key;
    }
    // Called by showFilter()
    private flag_filter(key: string) {
        let filter: (Registrant, string) => boolean;
        switch (key) {
            case 'all':
                filter = (data, k) => true;
                break;
            case 'invited':
                filter = (data, k) => data.inviteSent > 0;
                break;
            case 'not-invited':
                filter = (data, k) => data.inviteSent == 0;
                break;
            case 'attending':
                filter = (data, k) => data.attending == 'accepted';
                break;
            case 'not-attending':
                filter = (data, k) => data.attending == 'declined';
                break;
            case 'checked-in':
                filter = (data, k) => data.checkedIn > 0;
                break;
            case 'not-checked-in':
                filter = (data, k) => data.checkedIn == 0;
                break;
            case 'walkups':
                filter = (data, k) => data.walkin;
                break;
        }
        return filter;
    }

    applyFilter(filterValue: string) {
        this.dataSource.filterPredicate = this.searchFilter.bind(this);
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    private searchFilter(data: Registrant, keyword: string): boolean {
        const accumulator = (currentTerm, key) => currentTerm + data[key];
        const dataStr = Object.keys(data).filter(k => this.search_array.indexOf(k) > -1).reduce(accumulator, '').toLowerCase();
        const transformedFilter = keyword.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) != -1;
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }


    public checkToSendEmail(ev, type, reg) {
        setTimeout( _ => {
            reg['send_' + type] = !reg['send_' + type];
            this[type + '_selected_num'] = 0;
            this.dataSource.data.forEach( d => {
                if (d['send_' + type]) {
                    this[type + '_selected_num'] += 1;
                }
            });
        }, 10);
        ev.stopPropagation();
    }

    confirmRestoreUids() {
        console.log('amount ',);
        let crDialog;
        crDialog = this.dialog['open'](CustomUidsDialog,{
            width: '500px',
            data: { type: 'restore', amount:this.registrantCount }
        });

        crDialog.afterClosed().subscribe(result => {
            if(result) this.restoreUids();
        })
    }

    restoreUids() {
        const regRef = this.afs.collection(`accounts/${this.state.accounts['currentId']}/registrants/`);
        regRef.ref.get().then(query => {
            const batch = this.afs.app.firestore().batch();
            query.forEach(doc => {
                const d = doc.data();
                if (d.eventId == this.state.checkit.event.eventId) {
                    batch.update(doc.ref, 'scanId', this.afs.createId());
                }
            });
            return batch.commit()
        }).then( x => {
            const regRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.state.checkit.event.eventId}`);
            regRef.update({use_custom_id:false}).then(_=>{
                const scanId_pos = this.displayedColumns.indexOf('scanId');
                if(scanId_pos > -1){
                    this.displayedColumns.splice(scanId_pos,1);
                }
                let data = {
                    msg:this.registrantCount + ' ids restored successfully',
                    after_icon: 'check',
                    after_class: 'text-green'};
                this.snackbar.openFromComponent(IconedSnackBar,{duration: 6000, data: data});
            });
        });

    }

    // Update registrant
    updateRegistrant(ev, reg){
        if (!this.permission['event-individual-edit']) {
            return;
        }
        if (!ev.target.classList.contains('menu')) {
            let srDialog;
            srDialog = this.dialog.open(RegistrantDialogComponent, {
                width: '500px',
                data: { evnt: this.evnt, registrant: Object['assign']({}, reg) }
            });

            srDialog.afterClosed().subscribe(result => {
                if (result && result.registrant && result.registrant.hasOwnProperty('registrantId')){
                    const regId = result.registrant.registrantId;
                    const regRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/registrants/${regId}`);
                    delete result.registrant.send_invitation;
                    delete result.registrant.send_ticket;
                    delete result.registrant.send_email;
                    delete result.registrant.show_detail;
                    if (typeof result.registrant.checkedIn == "boolean") {
                        result.registrant.checkedIn = result.registrant.checkedIn ? Math.floor(Date.now() / 1000) : 0;
                    }
                    if (typeof result.registrant.walkin == "boolean") {
                        result.registrant.walkin = result.registrant.walkin ? Math.floor(Date.now() / 1000) : 0;
                    }
                    regRef.update(result.registrant);
                }
            });
        }
    }

    private add_individual(individual): Promise<any> {
        // Must be sure no duplicate email before calling this function
        const regId = this.afs.createId();
        const regRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/registrants/${regId}`);
        const default_idv = { eventId: this.state.checkit.event.eventId, attending: 'pending', walkin: false, method: 'call_addition',
            created: new Date(), createdBy: this.state.uid, scanId: this.afs.createId(), registrantId: regId,
            inviteSent: 0, ticketSent: 0, checkedIn: 0, attendingResponse: 0
        }
        const registrant = {...default_idv, ...individual};
        return regRef.set(registrant).then( _ => registrant);
    }

    // Add registrant
    addRegistrant(){
        let nrDialog = this.dialog.open(RegistrantDialogComponent, {
            width: '480px',
            data: {
                evnt: this.evnt,
                registrant: {
                    eventId: this.state.checkit.event.eventId,
                    attending: 'pending',
                    walkin: false,
                    method: 'manual_addition',
                    created: firestore.FieldValue.serverTimestamp(),
                    createdBy: this.state.uid,
                    inviteSent: 0,
                    ticketSent: 0,
                    checkedIn: 0,
                    attendingResponse: 0
                }
            }
        });
        nrDialog.afterClosed().subscribe(result => {
            if (result && result.registrant){
                console.log("result = " ,result);
                if (typeof result.registrant.checkedIn == "boolean") {
                    result.registrant.checkedIn = result.registrant.checkedIn ? Math.floor(Date.now() / 1000) : 0;
                }
                if (typeof result.registrant.walkin == "boolean") {
                    result.registrant.walkin = result.registrant.walkin ? Math.floor(Date.now() / 1000) : 0;
                }
                console.log('date ',new Date())
                const regId = result.registrant.hasOwnProperty('registrantId') ? result.registrant.registrantId : this.afs.createId();
                const regRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/registrants/${regId}`);
                if(result.registrant.hasOwnProperty('registrantId')){
                    regRef.update(result.registrant);
                }else{
                    result.registrant.registrantId = regId;
                    if(!result.registrant.scanId) result.registrant.scanId = this.afs.createId();
                    regRef.set(result.registrant);
                }

                const data = {
                    msg:result.registrant.firstName + ' ' + result.registrant.lastName + ' added',
                    after_icon: 'check',
                    after_class: 'text-green'};
                this.snackbar.openFromComponent(IconedSnackBar,{duration:6000,data:data});
            }});
    }

    // Delete Registrant
    deleteRegistant(reg) {
        const drDialog = this.dialog.open(DeleteRegistantDialog, { width: '480px', data: { registrant: reg } });
        drDialog.afterClosed().subscribe(result => {
            console.log("result = ", result);
            if (result && result.registrant) {
                if (typeof result.registrant === 'string' && result.registrant == 'all') {
                    const regRef = this.afs.collection(`accounts/${this.state.accounts['currentId']}/registrants/`);
                    // , ref => {
                    //     console.log(this.state.checkit.event.eventId);
                    //     return ref.where('eventId', '==', this.state.checkit.event.eventId)
                    // });
                    regRef.ref.get().then(query => {
                        const batch = this.afs.app.firestore().batch();
                        query.forEach(doc => {
                            const d = doc.data();
                            if (d.eventId == this.state.checkit.event.eventId) {
                                batch.delete(doc.ref)
                            }
                        });
                        return batch.commit()
                    }).then( () => this.alert_message = 'List cleared');

                } else if (result.registrant.hasOwnProperty('registrantId')) {
                    const regId = result.registrant.registrantId;
                    const regRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/registrants/${regId}`);
                    regRef.delete();

                    const data = {msg: result.registrant.firstName + ' ' + result.registrant.lastName + ' has been deleted'};
                    this.snackbar.openFromComponent(IconedSnackBar, {duration: 6000, data: data});
                }
            }
        });
    }

    // Edit email Dialog, called by viewEmail()
    public edit_email(type) {
        let email;
        if (type == 'invitation') {
            email = this.evnt.invitationMail ? this.evnt.invitationMail : this.invitation_default_mail;
        } else if (type == 'email') {
            email = this.evnt.emailMail ? this.evnt.emailMail : this.email_default_mail;
        } else if (type == 'ticket') {
            email = this.evnt.ticketMail ? this.evnt.ticketMail : this.ticket_default_mail;
        }
        const iDialog = this.dialog.open(EmailEditDialogComponent, { width: '800px', data:  {type: type, email: email}});
        iDialog.afterClosed().subscribe(result => {
            if (result) {
                const eventRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.state.checkit.event['eventId']}`);
                if (type == 'invitation') {
                    eventRef.update({invitationMail: result});
                    this.evnt.invitationMail = result;
                } else if (type == 'ticket') {
                    eventRef.update({ticketMail: result});
                    this.evnt.ticketMail = result;
                }
            }
        })
    }

     // called by sendBatchEmail()
    private send_batch_emails(type) {
        const pDialog = this.dialog.open(ProgressMessageDialogComponent, { width: '480px',
            data: {title: 'Sending', message: 'Sending... do not close the browser window.',
                buttonText: 'Done'}
        });

        const ready_to_post_emails = [];
        const checkbox_type = 'send_' + type;
        const email_obj = this.evnt[type + 'Mail'] ? this.evnt[type + 'Mail'] : this[type + '_default_mail'];
        let total = 0;
        let check_sum = 0;
        this.dataSource.data.forEach( dd => {
            if (dd[checkbox_type]) total++;
        });
        this.dataSource.data.forEach( (d, i) => {
            // setTimeout should be remove while release the app
            setTimeout( () => {
                if (d[checkbox_type]) {
                    check_sum++;
                    let final_content = this['rendered_' + type + '_content'].replace('{{first_name}}', d.firstName);
                    if (type == 'ticket') {
                        final_content = final_content.replace('{{scanId}}', d.scanId);
                    }

                    const rsvp = this.state.accounts['currentId'] + '-' + d.registrantId + '-' + this.state.checkit.event['eventId'] + '-';
                    const mail = {
                        FromEmail: this.sender_email,
                        FromName: email_obj.sender,
                        Subject: email_obj.subject,
                        "Text-part": 'This is an invitation email',
                        "Html-part": final_content,
                        Recipients: [{Email: d.email}],
                        rsvp: rsvp,
                        type: type
                    };
                    const progress = 100 * check_sum / total;
                    const response = this.email.sentmail(mail);
                    if (progress < 100) {
                        pDialog.componentInstance.prepare_progress.next({ value: progress });
                    } else {
                        pDialog.componentInstance.prepare_progress.next({ value: progress, title: 'Success!',
                            message: 'Email sent to ' + total + ' people'});
                    }
                    response.subscribe(data => {
                        console.log('Email sent to', mail.Recipients[0]);
                        if (check_sum == total) {
                            this[type + '_selected_num'] = 0;
                            this.dataSource.data.forEach( d => d['send_' + type] = false );
                        }
                    });
                    // ready_to_post_emails.push(mail);
                }
            }, (i + 1) * 100)
        });
        // ready_to_post_emails.forEach( (email, i) => {
        //     pDialog.componentInstance.prepare_progress.next(100 * (i + 1) / total);
        //     console.log(100 * (i + 1) / total);
        //     const response = this.email.sentmail(email);
        //     response.subscribe(data => {
        //         console.log('Email sent to', email.Recipients[0]);
        //         if (i == ready_to_post_emails.length - 1) {
        //             this[type + '_selected_num'] = 0;
        //             this.dataSource.data.forEach( d => d['send_' + type] = false );
        //         }
        //     });
        // });
    }

    // called by viewEmail()
    private send_single_email(progress: Subject<any>, type = 'invitation', reg: Registrant) {
        const email_obj = this.evnt[type + 'Mail'] ? this.evnt[type + 'Mail'] : this[type + '_default_mail'];

        // setTimeout should be remove while release the app
        setTimeout( () => {
            let final_content = '';
            if (type == 'invitation') {
                final_content = this.rendered_invitation_content.replace('{{first_name}}', reg.firstName);
            } else if (type == 'email') {
                final_content = this.rendered_email_content.replace('{{first_name}}', reg.firstName);
            } else if (type == 'ticket') {
                final_content = this.rendered_ticket_content.replace('{{first_name}}', reg.firstName)
                    .replace('{{scanId}}', reg.scanId);
            }
            const rsvp = this.state.accounts['currentId'] + '-' + reg.registrantId + '-' + this.state.checkit.event['eventId'] + '-';
            const mail = {
                FromEmail: this.sender_email,
                FromName: email_obj.sender,
                Subject: email_obj.subject,
                "Text-part": 'This is an email',
                "Html-part": final_content,
                Recipients: [{Email: reg.email}],
                rsvp: rsvp,
                type: type
            };
            const response = this.email.sentmail(mail);
            response.subscribe(data => {
                const message = 'Email sent to ' + mail.Recipients[0].Email;
                progress.next({ value: 100, title: 'Success!', message: message});
            });
        }, 200);
    }

    // Check if user was added in the event list. Called by viewEmail() & sendBatchMail()
    private send_test_email(type) {
        this.afs.collection<Registrant>(`accounts/${this.state.accounts['currentId']}/registrants`,ref => ref
            .where('eventId', '==', this.state.checkit.event['eventId'])
            .where('email', '==', this.auth_email)).valueChanges().take(1).subscribe( regs => {
            const buttonText = regs.length == 0 ? 'Add details & send test' : 'send test';
            this.dialog.open(SendTestDialogComponent, { width: '480px',
                data: {buttonText: buttonText, email: this.auth_email, fullname: this.default_sender }
            }).afterClosed().subscribe( cmd => {
                if (cmd && cmd.cmd == 'send') {
                    if (regs.length == 0) {
                        const registrant = {email: this.auth_email, firstName: this.auth_firstName,
                            lastName: this.auth_lastName, company: '', phone: ''};
                        this.add_individual(registrant).then(reg => {
                            const pDialog = this.dialog.open(ProgressMessageDialogComponent, { width: '480px',
                                data: {title: 'Sending', message: 'Sending... do not close the browser window.',
                                    buttonText: 'Done'}
                            });
                            this.send_single_email(pDialog.componentInstance.prepare_progress, type, reg);
                        });
                    } else {
                        const pDialog = this.dialog.open(ProgressMessageDialogComponent, { width: '480px',
                            data: {title: 'Sending', message: 'Sending... do not close the browser window.',
                                buttonText: 'Done'}
                        });
                        this.send_single_email(pDialog.componentInstance.prepare_progress, type, regs[0]);
                    }
                }
            });
        });
    }

    // Render email content, called by prepare_html_template()
    private render_email(type, html_text) {
        let body = '';
        let logo = '';
        if (type == 'invitation') {
            body = this.evnt.invitationMail ? this.evnt.invitationMail.body : this.invitation_default_body;
            logo = this.evnt.invitationMail ? this.evnt.invitationMail.logo : '';
        } else if (type == 'email') {
            body = this.evnt.emailMail ? this.evnt.emailMail.body : this.email_default_body;
            logo = this.evnt.emailMail ? this.evnt.emailMail.logo : '';
        } else if (type == 'ticket') {
            body = this.evnt.ticketMail ? this.evnt.ticketMail.body : this.ticket_default_body;
            logo = this.evnt.ticketMail ? this.evnt.ticketMail.logo : '';
        }
        body = body.replace(/\n/g, '<br/>');
        const dd =this.datePipe.transform(this.evnt.date['toDate'](), 'EEEE d MMMM y');
        const start = this.timePipe.transform(this.evnt.start);
        const end = this.timePipe.transform(this.evnt.end);
        const start_to_end = start + (start && end ? " - " : '') + end ;
        const current_year = new Date().getFullYear();
        let html = html_text.replace('{{date}}', dd)
            .replace('{{start_to_end}}', start_to_end )
            .replace('{{venue}}', this.evnt.venue || '')
            .replace('{{address}}', this.evnt.address || '')
            .replace(new RegExp('{{venue_url}}', 'g'), this.evnt.venue_url || '')
            .replace('{{current_year}}', current_year )
            .replace('{{body}}', body);
        if(!this.evnt.venue){
            html = html.replace('<!-- if-venue -->','<!-- if-venue').replace('<!-- end-if-venue -->',' end-if-venue -->')
        }
        if (logo != '') {
            html = html.replace('{{noLogo}}', '');
        } else {
            html = html.replace('{{noLogo}}', 'display: none');
        }
        html = html.replace('{{logo}}', logo);
        return html;
    }

    // Called by viewEmail(), sendBatchMail() and sendSingleEmail()
    private prepare_html_template(type) {
        const html_data = new Subject<string>();
        const template = this[type + '_template'];
        let email_content = '';

        if (window.location.hostname == 'localhost') {
            this.http.get(`assets/${template}`, {responseType: 'text'}).subscribe( html => {
                email_content = this.render_email(type, html);
                this['rendered_' + type + '_content'] = email_content;
                html_data.next(email_content);
            });
        } else {
            const ref = this.storage.ref(`templates/${template}`);
            ref.getDownloadURL().subscribe( url => {
                this.http.get(url, {responseType: 'text'}).subscribe( html => {
                    email_content = this.render_email(type, html);
                    this['rendered_' + type + '_content'] = email_content;
                    html_data.next(email_content);
                });
            });
        }
        return html_data;
    }



    // Preview invitation, ticket or simple emails
    public viewEmail(type) {
        const html_data = this.prepare_html_template(type);
        const email_obj = this.evnt[type + 'Mail'] ? this.evnt[type + 'Mail'] : this[type + '_default_mail'];

        html_data.subscribe( data => {
            const iDialog = this.dialog.open(PreviewDialogComponent, { width: '800px',
                data: {action: 'preview', type: type, html: data, email_obj: email_obj} });
            iDialog.afterClosed().subscribe(command => {
                if (command && command.cmd == 'edit') {
                    this.edit_email(type);
                } else if (command && command.cmd == 'send_test') {
                    this.send_test_email(type);
                }
            })
        });
    }

    // Select recipients for invitation, ticket or simple emails
    public selectRecipients(type) {
        this.dialog.open(RecipientsDialogComponent, { width: '480px', data: {stats: this.stats}}).afterClosed().subscribe( recipients => {
            if (recipients) {
                if (recipients == 'all') {
                    this[type + '_selected_num'] = this.dataSource.data.length;
                    this.dataSource.data.forEach(d => d['send_' + type] = true);
                } else {
                    this[type + '_selected_num'] = 0;
                    let counter = 0;
                    let compare;
                    switch (recipients) {
                        case 'invited':
                            compare = (d) => d['inviteSent'] != 0;
                            break;
                        case 'not-invited':
                            compare = (d) => d['inviteSent'] === 0;
                            break;
                        case 'attending':
                            compare = (d) => d['attending'] == 'accepted';
                            break;
                        case 'not-attending':
                            compare = (d) => d['attending'] == 'declined';
                            break;
                        case 'checked-in':
                            compare = (d) => d['checkedIn'] != 0;
                            break;
                        case 'not-checked-in':
                            compare = (d) => d['checkedIn'] === 0;
                            break;
                        case 'walkups':
                            compare = (d) => d['walkin'];
                            break;
                    }
                    if (compare) {
                        this.dataSource.data.forEach( d => {
                            if (compare(d)) {
                                d['send_' + type] = true;
                                counter++;
                            } else {
                                d['send_' + type] = false;
                            }
                        });
                    }
                    this[type + '_selected_num'] = counter;
                }
                console.log(this[type + '_selected_num']);
            }
        });
    }

    // Send batch recipients for invitation, ticket or simple emails
    public sendBatchEmail(type) {
        const selected_num = this[type + '_selected_num'];
        if (selected_num == 0) {
            this.dialog.open(ProgressMessageDialogComponent, { width: '480px',
                data: {title: 'Oops...', message: 'Please select recipients before sending your email.',
                    buttonText: 'OK', titleBgColor: '#e25', action: 'success'}
            });
        } else {
            const html_data = this.prepare_html_template(type);
            const email_obj = this.evnt[type + 'Mail'] ? this.evnt[type + 'Mail'] : this[type + '_default_mail'];

            html_data.subscribe( data => {
                const iDialog = this.dialog.open(PreviewDialogComponent, { width: '800px',
                    data: {action: 'send', type: type, html: data, selected_num: selected_num, email_obj: email_obj} });
                iDialog.afterClosed().subscribe(command => {
                    if (command && command.cmd == 'send') {
                        this.send_batch_emails(type);
                    } else if (command && command.cmd == 'send_test') {
                        this.send_test_email(type);
                    }
                })
            });
        }
    }

    // Send email to an assigned recipient for invitation, ticket or simple email
    public sendSingleEmail(type, reg) {
        const html_data = this.prepare_html_template(type);
        const email_obj = this.evnt[type + 'Mail'] ? this.evnt[type + 'Mail'] : this[type + '_default_mail'];

        html_data.subscribe( data => {
            const iDialog = this.dialog.open(PreviewDialogComponent, { width: '800px',
                data: {action: 'send_one', type: type, html: data, email_obj: email_obj, reg: reg} });
            iDialog.afterClosed().subscribe(command => {
                if (command && command.cmd == 'send_one') {
                    const pDialog = this.dialog.open(ProgressMessageDialogComponent, { width: '480px',
                        data: {title: 'Sending', message: 'Sending... do not close the browser window.',
                            buttonText: 'Done'}
                    });
                    this.send_single_email(pDialog.componentInstance.prepare_progress, type, reg);
                } else if (command && command.cmd == 'send_test') {
                    this.send_test_email(type);
                }
            })
        });
     }



    // When 'IMPORT' button is pressed
    public importAction(ev) {
        this.zones_status[0] = 0;
        if (ev.action === 'save') {
            this.import_data = ev;
            this.saveToDB();
        }
    }
    private saveToDB() {
        const batch = this.afs.firestore.batch();
        let count = 0;
        let registrantCollection = this.afs.collection<Registrant>(`accounts/${this.state.accounts['currentId']}/registrants`,
                ref => ref.where("eventId", '==', this.state.checkit.event['eventId']) );
        let use_custom_id = false;
        this.import_data.data.forEach(d => {
            let scanId = this.afs.createId();
            const id = this.afs.createId();
            const uid_index = this.import_data.column_fields.findIndex( x => x == 'uid');
            const email_index = this.import_data.column_fields.findIndex( x => x == 'email');
            const first_index = this.import_data.column_fields.findIndex( x => x == 'firstName');
            const last_index = this.import_data.column_fields.findIndex( x => x == 'lastName');
            const company_index = this.import_data.column_fields.findIndex( x => x == 'company');
            const phone_index = this.import_data.column_fields.findIndex( x => x == 'phone');
            if(uid_index > -1){
                //TODO: somehow make sure that the id is unique, and set a flag for this event to be unique
                scanId = d[uid_index];
                use_custom_id = true;
            }
            const docRef = registrantCollection.ref.doc(id);
            const reg = {
                registrantId: id,
                email: (d[email_index] || ''),
                firstName: (d[first_index] || ''),
                lastName: (d[last_index] || ''),
                company: company_index == -1 ? '' : (d[company_index] || ''),
                phone: phone_index == -1 ? '' : (d[phone_index] || '') ,
                eventId: this.state.checkit.event.eventId || null,
                attending: 'pending',
                walkin: false,
                method: 'batch_addition',
                created: new Date(),
                createdBy: this.state.uid,
                scanId: scanId,
                inviteSent: 0,
                ticketSent: 0,
                checkedIn: 0,
                attendingResponse: 0
            };
            count++;
            // console.log(reg);
            if (reg.email) {
                batch.set(docRef, reg);
            }
        });
        if(use_custom_id){ // && !event.use_custom_id
            this.state.$requests.next({request: 'setCustomIdUsage', use_custom_id: true});
            const eventRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.state.checkit.event['eventId']}`);
            eventRef.update({use_custom_id: true});
        }
        batch.commit().then(_ => {
            this.alert_message = count + ' people added to event';
            this.import_data.afterSave.next('saved');
            this.zones_status[0] = 0;
            const data = {
                msg: count + ' imported successfully',
                after_icon: 'check',
                after_class: 'text-green'};
            this.snackbar.openFromComponent(IconedSnackBar,{duration: 6000, data: data});
        });
    }

    public zoneToggle(idx: number, type = '') {
        if (this.displayedColumns.length == 0) return;
        for (let i = 0; i < this.zones_status.length; i++) {
            if (i == idx && this.zones_status[i] == 0) {
                this.zones_status[i] = 1;
            } else {
                this.zones_status[i] = 0;
            }
        }
        if(this.displayedColumns[this.displayedColumns.length - 1] != 'actions') { // place actions if that column doesn't exist
            this.displayedColumns.push('actions');
        }
        if (!type) {
            if (this.displayedColumns[0].indexOf('check_') > -1) {
                this.displayedColumns.shift();
            }
            // for (let i = 0; i < this.zones_status.length; i++) this.zones_status[i] = 0;
            return;
        }
        if (this.displayedColumns[0].indexOf('check_') > -1) { // some checkbox is there
            this.displayedColumns.shift();
        }
        if (this.zones_status[idx] == 1 && this.displayedColumns[0].indexOf('check_' + type) < 0) { // no chckbox
            setTimeout( () => {
                this.displayedColumns.unshift('check_' + type);
                this.displayedColumns.pop(); // remove actions that were possibly just placed
            }, 10);
        }
    }
    public toggleListCheckbox(type) {
        setTimeout( _ => {
            if (this[type + '_selected_num'] == this.dataSource.data.length) {
                this[type + '_selected_num'] = 0;
                this.dataSource.data.forEach( d => d['send_' + type] = false );
            } else {
                this[type + '_selected_num'] = this.dataSource.data.length;
                this.dataSource.data.forEach( d => d['send_' + type] = true );
            }
        }, 100);
    }

    public chboxIndeterminate(type) {
        return 0 < this[type + '_selected_num'] && this[type + '_selected_num'] < this.dataSource.data.length;
    }

    public checkinInformation(){
        this.dialog.open(CheckinInformationDialogComponent, { width: '800px'});
    }

    public openEmailApp() {
        const dd = this.datePipe.transform(this.evnt.date['toDate'](), 'EEEE d MMMM y');
        const start = this.timePipe.transform(this.evnt.start);
        const end = this.timePipe.transform(this.evnt.end);
        const start_to_end = start + (start && end ? " - " : '') + end ;
        const email_subject = 'Check-in information for ' +  this.evnt.title;
        const email_body =
            'Hi there!\n\n' +
            'Here are the check-in instructions for the following event:\n' +
            this.evnt.title + '\n' + start_to_end + ', ' + dd +
            ' \n\n\n' +
            'To start scanning:\n\n' +
            '1. Install the Checkit app on the device you will use for scanning.\n' +
            'iOS: https://www.checkit.events/iosapp\n' +
            'Android: https://www.checkit.events/androidapp\n\n' +
            '2. Open this email on the same device and click this link:\n' +
            'https://'+this.subdomain+'.checkit.events/check-in/' + this.state.accounts['currentId'] + '-' + this.state.checkit.event['eventId'] + '\n\n' +
            'Note: You can share this link with as many people as you need to check people into your event.\n\n\n\n';
        const url = 'mailto:' + this.auth_email + '?subject=' + email_subject + '&body=' + encodeURIComponent(email_body);
       /* const win = window.open(url, '_blank');
        win.focus();
        setTimeout(function(){
            if (!win.document.hasFocus()) {
                win.close();
            }
        }, 500);*/
         window.location.href = url;
    }

    private qrcode_url(el) {
        console.log(el.elementRef.nativeElement.firstChild.outerHTML);
        return el.elementRef.nativeElement.firstChild.outerHTML;
    }

    ngOnDestroy() {
        this.$destroy.next();
        this.$destroy.complete();
    }

    hidden_func() {
        // const itemsRef = this.afs.collection('checkit-rules');
        // this.http.get('assets/8256_Checkit_rules.csv', {responseType: 'text'}).subscribe( csv => {
        //     const array = csv.split('\r\n');
        //     const field_arr = array[0].split(',');
        //     for (let i = 1; i < array.length; i++) {
        //         const x = array[i].split(',');
        //         const rule_name = x[0];
        //         const data = {};
        //         for (let j = 1; j < x.length; j++) {
        //             if (x[j] == 'true') {
        //                 data[field_arr[j]] = true;
        //             } else if (x[j] == 'false') {
        //                 data[field_arr[j]] = false;
        //             }
        //         }
        //         itemsRef.doc(rule_name).set(data, {merge: true});
        //     }
        // });

    }
}



// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/components/event-dashboard.component.ts